export const LANGUAGE_HAS_BEEN_CHANGED = 'LANGUAGE_HAS_BEEN_CHANGED';
export const SET_TOOLTIP = 'SET_TOOLTIP';
export const CANCEL_OUTSIDE_CLICK_CHANGED = 'CANCEL_OUTSIDE_CLICK_CHANGED';
